module.exports = __webpack_public_path__ + "static/invoiceocean-8028cf8d672d54e11b48289c0bb5c2af.png";